import React, { PropsWithChildren } from 'react';
import { useQuery } from '@tanstack/react-query';
import MarketStateService from '@app/model/market_state/service/MarketStateService';
import { MarketStateNotificationsQueryKeys } from '@app/model/market_state/service/MarketStateGraphQLQueryKeys';
import MarketStateForDayNotificationsOutput from '@app/model/market_state/MarketStateForDayNotificationsOutput';
import CalendarMonth from '@app/state/calendar/CalendarMonth';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';

export const MarketStateNotificationsForMonthContext = React.createContext<MarketStateForDayNotificationsOutput[]>([]);

const MarketStateNotificationsForMonthProvider: React.FunctionComponent<PropsWithChildren<{
	companyHotel: CompanyHotel,
	calendarMonth: CalendarMonth
}>> = ({ companyHotel, calendarMonth, children }) => {

	const { data, isSuccess } = useQuery({
		queryFn: () => MarketStateService.findAlertExecutionNotificationsForPeriod({
			companyHotelId: companyHotel.id,
			startStatDate: calendarMonth.range.startStatDate,
			endStatDate: calendarMonth.range.endStatDate
		}),
		refetchOnWindowFocus: false,
		queryKey: MarketStateNotificationsQueryKeys.marketStateNotifications(companyHotel.id, calendarMonth.index.year, calendarMonth.index.month),
	});

	if (isSuccess) {
		return <MarketStateNotificationsForMonthContext.Provider
			value={data}>{children}</MarketStateNotificationsForMonthContext.Provider>;
	}

	return children;
};

export default MarketStateNotificationsForMonthProvider;